<template>
  <div>
    <v-btn color="primary" dark class="mb-2 hbtn" to="/hotels/create"
      >{{ $t("companiesPage.new") }}</v-btn
    >
    <DataTable
      :url="api.ACTIONS.PASSENGERS"
      :titles="titles"
      :fields-hidden-main="['deleted_at', 'updated_at', 'billing_email', 'address', 'phone_number']"
      :fields-hidden-add="['id', 'deleted_at', 'created_at', 'updated_at', 'address']"
      :input-types-add="{
        password: 'password',
        password_confirmation: 'password',
      }"
      :formatter="formatters"
      :title="$t('companiesPage.tableHotelsUsers')"
      :enableEdit="false"
      :enableAdd="false"
      :add-rules="rules"
      :initial-url-search-params="par"
      :actions-extra-main="actionsExtraMain"
    />
  </div>
</template>

<style>
.hbtn {
  float: inline-end;
  z-index: 1;
  margin-top: 20px;
  margin-inline-end: 20px;
  padding: 0px 45px;
}
</style>

<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";
import { companyToday, formatCompanyTime } from "@/util/companyTime";

const required = (val) =>
  (val !== null && val !== undefined) || "this field is required";
const email = (val) =>
  (!!val && val.search(/^(\w|-|\.|_)+@(\w|-|\.|_)+\.\w+$/) !== -1) ||
  "this must be a valid email";
const past = (val) =>
  (!!val && moment(val).format("YYYY-MM-DD") < companyToday()) ||
  "this must be past date";

export default {
  name: "Hotels",
  title() {
    return this.$t("companiesPage.hotelsPageTitle");
  },
  components: { DataTable },
  data() {
    return {
      accommodation: "hotel",
      formatters: {
        created_at(value) {
          return formatCompanyTime(value, " DD MMM YYYY");
        },
      },
    };
  },

  computed: {
    rules() {
      return {
        username: [required],
        password: [required],
      };
    },
    par() {
      const par = new URLSearchParams();
      par.append("type", this.accommodation);
      return par;
    },
    titles() {
      return {
        id: this.$t("companiesPage.colNumber"),
        username: this.$t("companiesPage.colEmail"),
        username: this.$t("companiesPage.colUserName"),
        full_name: this.$t("companiesPage.colHotelName"),
        phone: this.$t("companiesPage.colPhone"),
        created_at: this.$t("companiesPage.colCreationDate"),
      };
    },
    actionsExtraMain() {
      return {
        prices: {
          title: this.$t("companiesPage.profile"),
          icon: "edit",
          action: (item) =>
            this.$router.push({
              name: "PassengerProfile",
              params: { id: item.id },
            }),
        },
      };
    },
  },
};
</script>
